import { environment } from '@env/environment';
import { resolveActiveBaseDomain } from '@domain/base-domain';

export function isCookiePolicyEnabledOn(hostname: string | undefined): boolean {
  const { cookiePolicyDisabled, cookiePolicyDomain } = environment;
  if (cookiePolicyDisabled || !cookiePolicyDomain) {
    return false;
  }

  return !!resolveActiveBaseDomain(hostname, [cookiePolicyDomain]);
}

export function initCookieYesFunction() {
  return () => {
    if (!isCookiePolicyEnabledOn(location.hostname)) {
      return;
    }

    const n = document.createElement('script');
    n.type = 'text/javascript';
    n.src = 'https://cdn-cookieyes.com/client_data/ceb442b1d9f2080d1293d4be/script.js';
    n.async = !0;
    const a = document.getElementsByTagName('script')[0];
    a.parentNode.insertBefore(n, a);
  };
}
